import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgbCollapseModule, NgbDropdownModule, NgbModalModule, NgbNavModule, NgbAlertModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { AppRoutingModule, routingComponents } from './app-routing.module';
import { SecAdminUserService } from './services/sec-admin-user.service';
import { AuthGuardService } from './services/auth-guard.service';
import { UnauthorizedInterceptorService } from './services/unauthorized-interceptor.service';
import { UserDetailComponent } from './components/user-detail/user-detail.component';
import { CheckboxGroupComponent } from './components/shared/checkbox-group/checkbox-group.component';
import { ConfirmationComponent } from './components/shared/confirmation/confirmation.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    routingComponents,
    UserDetailComponent,
    CheckboxGroupComponent,
    ConfirmationComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbCollapseModule,
    NgbDropdownModule,
    NgbModalModule,
    NgbNavModule,
    NgbAlertModule,
    NgbTooltipModule,
    ReactiveFormsModule
  ],
  providers: [
    SecAdminUserService,
    AuthGuardService,
    { provide: HTTP_INTERCEPTORS, useClass: UnauthorizedInterceptorService, multi: true },
    Title,
    provideHttpClient(withInterceptorsFromDi())
  ]
})

export class AppModule { }
